import React, { useEffect, useRef, useState } from "react";
import "./SettingsDrawerContent.scss";
import { Divider, Icon, Modal, Typography } from "antd";
import { connect } from "react-redux";
import {
  GetCurrentStoreData,
  SaveWebsiteBackup,
  WebsitesState,
} from "../../store/websites/types";
import { AuthState } from "../../store/auth/types";
import classNames from "classnames";
import WebsiteSettings from "./WebsiteSettings";
import WebsitePageSettings from "./WebsitePageSettings";
import AccountSettings from "./account/account_settings/AccountSettings";
import BlogSettings from "./BlogSettings";
import BlogPostSettings from "./BlogPostSettings";
import "./Settings.css";
import {
  getCurrentStoreData,
  getSingleWebsiteLoadStatus,
  saveWebsiteBackup,
} from "../../store/websites/thunks";
import InternalSettings from "./InternalSettings";
import { UserState } from "../../store/user/types";
import _ from "lodash";
import SaveChangesButtons from "./SaveChangesButtons";
import UnsavedChangesModal from "./UnsavedChangesModal";
import { setUserStateData } from "../../store/user/actions";
import {
  Blocks,
  BookText,
  Bot,
  CircleUserRound,
  Coffee,
  CreditCard,
  Crown,
  Download,
  Globe,
  KeyRound,
  LayoutGrid,
  LayoutTemplate,
  NotebookPen,
  Rocket,
  Settings,
  User,
  Users,
  UsersRound,
} from "lucide-react";
import { getCurrentPageId } from "../../helpers/getCurrentPageId";
import { getPageLoadStatus } from "../../store/websitePages/thunks";
import { LoadStatus } from "../../enums/enums";
import SpinnerBox from "./SpinnerBox";
import { getSingleBlogLoadStatus } from "../../store/blogs/thunks";
import { getSinglePostLoadStatus } from "../../store/blogPosts/thunks";
import { PlansState } from "../../store/plans/types";

const { Text } = Typography;

export type ActiveMenu =
  | "account"
  | "account__plan"
  | "account__billing"
  | "account__applications"
  | "websiteSettings"
  | "customDomain"
  | "colorsAndFonts"
  | "widgets"
  | "exportHtml"
  | "pageSettings"
  | "blogSettings"
  | "postSettings"
  | "collaborators"
  | "internal__admin"
  | "internal__pageTemplate"
  | "cms"
  | "seo";
interface Props {
  user: UserState;
  websites: WebsitesState;
  auth: AuthState;
  getCurrentStoreData: GetCurrentStoreData;
  saveWebsiteBackup: SaveWebsiteBackup;
  setUserStateData: any;
  plans: PlansState;

  history: any;
  saveWebsitePageDataInStore: any;
  saveWebsiteDataInStore: any;
  saveBlogDataInStore: any;
  saveBlogPostDataInStore: any;
  publishPage: any;
  publishPost: any;
  saveImageInfoInDB: any;
  removeImageFromDB: any;
  type: string;
  setDrawerWidth: any;
  getPageLoadStatus: any;
  getSingleBlogLoadStatus: any;
  getSinglePostLoadStatus: any;
  getSingleWebsiteLoadStatus: any;
  setIsWide: any;
}

interface SidebarButtonGroupProps {
  children: React.ReactNode;
  title: string;
  condition?: boolean;
}
const SidebarButtonGroup = (props: SidebarButtonGroupProps) => {
  const { children, title, condition } = props;
  if (condition === false) return null;
  return (
    <div className="settings-drawer__sidebar-button-group">
      <Text
        ellipsis={false}
        className="gpt-assistant__presets-dropdown-group-title"
      >
        {title}
      </Text>
      {children}
    </div>
  );
};
interface SidebarButtonProps {
  children?: React.ReactNode;
  menuTitle?: ActiveMenu;
  activeMenu?: ActiveMenu;
  setActiveMenu?: React.Dispatch<React.SetStateAction<ActiveMenu>>;
}
const SidebarButton = ({
  children,
  activeMenu,
  setActiveMenu,
  menuTitle,
}: SidebarButtonProps) => {
  const handleOnClick = () => {
    setActiveMenu(menuTitle);
  };
  return (
    <button
      className={classNames("settings-drawer__sidebar-button", {
        "is-active": activeMenu === menuTitle && !!activeMenu && !!menuTitle,
      })}
      onClick={handleOnClick}
    >
      <span className="settings-drawer__sidebar-button-inner">{children}</span>
    </button>
  );
};

interface SettingsMenuProps extends Props {
  currentMenuTitle: ActiveMenu;
  setActiveMenu: React.Dispatch<React.SetStateAction<ActiveMenu>>;
}
const SettingsMenu = (props: SettingsMenuProps) => {
  const { currentMenuTitle, setActiveMenu } = props;
  if (currentMenuTitle.startsWith("account")) {
    if (!props.plans.dataFetched || !props.user.dataFetched) {
      return (
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <SpinnerBox text="Loading account data..." />
        </div>
      );
    }
    return (
      <AccountSettings
        history={props.history}
        currentMenuTitle={currentMenuTitle}
      />
    );
  }
  if (currentMenuTitle.startsWith("page")) {
    const pageId = getCurrentPageId();
    const singlePageStatus = props.getPageLoadStatus(pageId);
    if (singlePageStatus !== LoadStatus.LOADED) {
      return (
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <SpinnerBox text="Loading page..." />
        </div>
      );
    }
    return (
      <WebsitePageSettings
        saveWebsitePageDataInStore={props.saveWebsitePageDataInStore}
        publishPage={props.publishPage}
        history={props.history}
        saveImageInfoInDB={props.saveImageInfoInDB}
        removeImageFromDB={props.removeImageFromDB}
        currentMenuTitle={currentMenuTitle}
      />
    );
  }
  if (currentMenuTitle.startsWith("blog")) {
    const { currentBlog } = props.getCurrentStoreData();
    const singleBlogStatus = props.getSingleBlogLoadStatus(currentBlog);
    if (singleBlogStatus !== LoadStatus.LOADED) {
      return (
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <SpinnerBox text="Loading blog..." />
        </div>
      );
    }
    return (
      <BlogSettings
        saveImageInfoInDB={props.saveImageInfoInDB}
        removeImageFromDB={props.removeImageFromDB}
        saveBlogPostDataInStore={props.saveBlogPostDataInStore}
        saveBlogDataInStore={props.saveBlogDataInStore}
        publishPost={props.publishPost}
        currentMenuTitle={currentMenuTitle}
      />
    );
  }
  if (currentMenuTitle.startsWith("post")) {
    const postId = getCurrentPageId();
    const singlePostStatus = props.getSinglePostLoadStatus(postId);
    if (singlePostStatus !== LoadStatus.LOADED) {
      return (
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <SpinnerBox text="Loading post..." />
        </div>
      );
    }
    return (
      <BlogPostSettings
        saveBlogPostDataInStore={props.saveBlogPostDataInStore}
        publishPost={props.publishPost}
        saveImageInfoInDB={props.saveImageInfoInDB}
        removeImageFromDB={props.removeImageFromDB}
        currentMenuTitle={currentMenuTitle}
      />
    );
  }
  if (currentMenuTitle.startsWith("internal")) {
    return (
      <InternalSettings
        currentMenuTitle={currentMenuTitle}
        saveWebsitePageDataInStore={props.saveWebsitePageDataInStore}
      />
    );
  }

  const { currentWebsite } = props.getCurrentStoreData();
  const singleWebsiteStatus =
      props.getSingleWebsiteLoadStatus(currentWebsite);
  if (singleWebsiteStatus !== LoadStatus.LOADED) {
    return (
      <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
        <SpinnerBox text="Loading website..." />
      </div>
    );
  }
  return (
    <WebsiteSettings
      history={props.history}
      saveWebsitePageDataInStore={props.saveWebsitePageDataInStore}
      saveWebsiteDataInStore={props.saveWebsiteDataInStore}
      publishPage={props.publishPage}
      saveImageInfoInDB={props.saveImageInfoInDB}
      removeImageFromDB={props.removeImageFromDB}
      currentMenuTitle={currentMenuTitle}
      setActiveMenu={setActiveMenu}
    />
  );
};

const SettingsDrawerContent = (props: Props): JSX.Element => {
  const { type, getCurrentStoreData, saveWebsiteBackup } = props;
  const defaultSettingsMap = {
    website: "websiteSettings",
    page: "pageSettings",
    post: "postSettings",
    account: "account",
  };
  const [activeMenu, setActiveMenu] = useState<ActiveMenu>(
    defaultSettingsMap[type] as ActiveMenu
  );

  useEffect(() => {
    if (props.user.settings) {
      setActiveMenu(props.user.settings as ActiveMenu);
      props.setUserStateData({
        settings: null,
      });
    }
  }, [props.user.settings]);

  useEffect(() => {
    props.setDrawerWidth(activeMenu === "account__plan" ? "100%" : 640);
    return () => {
      props.setDrawerWidth(640);
    };
  }, [activeMenu]);
  const drawerRef = useRef<HTMLDivElement>(null);
  const isAdmin: boolean = _.get(props, "user.data.is_admin", false);
  const [isUnsavedChangesModalVisible, setIsUnsavedChangesModalVisible] =
    useState(false);
  const nextActiveMenu = useRef<ActiveMenu | null>(null);

  const onChangeActiveMenu: any = (menuTitle: ActiveMenu) => {
    const { currentWebsite } = getCurrentStoreData();
    if (
      _.get(currentWebsite, "hasUnsavedChanges") &&
      activeMenu === "colorsAndFonts" &&
      menuTitle !== "colorsAndFonts"
    ) {
      setIsUnsavedChangesModalVisible(true);
      nextActiveMenu.current = menuTitle;
      return;
    }
    setActiveMenu(menuTitle);
  };

  useEffect(() => {
    if (activeMenu === "account__plan") {
      props.setIsWide(true);
    } else {
      props.setIsWide(false);
    }
    return () => {
      props.setIsWide(false);
    }
  }, [activeMenu])

  return (
    <div className="settings-drawer__content" ref={drawerRef}>
      {(type === "website" || type === "account") && <div className="settings-drawer__sidebar">
        {/* <SidebarButtonGroup title="Blog post" condition={type === "post"}>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="postSettings"
          >
            <Icon type="setting" />
            Blog post settings
          </SidebarButton>
        </SidebarButtonGroup> */}

        {/* <SidebarButtonGroup title="Page" condition={type === "page"}>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="pageSettings"
          >
            <Icon type="setting" />
            Page settings
          </SidebarButton>
        </SidebarButtonGroup> */}

        {/* {type !== "starter" && <Divider />} */}

        <SidebarButtonGroup title="Website" condition={type === "website"}>
          {/* <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="colorsAndFonts"
          >
            <Icon type="bg-colors" />
            Website theme
          </SidebarButton> */}
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="websiteSettings"
          >
            <Settings size={16} />
            General
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="seo"
          >
            <Bot size={16} />
            SEO
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="collaborators"
          >
            <UsersRound size={16} />
            Collaborators
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="customDomain"
          >
            <Globe size={16} />
            Custom domain
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="widgets"
          >
            <LayoutGrid size={16} />
            Widgets
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="blogSettings"
          >
            <BookText size={16} />
            Blog
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="exportHtml"
          >
            <Download size={16} />
            Export HTML
          </SidebarButton>
        </SidebarButtonGroup>

        {/* {type !== "starter" && <Divider />} */}

        <SidebarButtonGroup
          title="Account"
          condition={type === "account" || type === "website"}
        >
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="account__plan"
          >
            <Crown size={16} />
            Upgrade
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="account__billing"
          >
            <CreditCard size={16} />
            Billing
          </SidebarButton>
          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="account"
          >
            <CircleUserRound size={16} />
            Account settings
          </SidebarButton>

          <SidebarButton
            activeMenu={activeMenu}
            setActiveMenu={onChangeActiveMenu}
            menuTitle="account__applications"
          >
            <KeyRound size={16} />
            Connections
          </SidebarButton>
        </SidebarButtonGroup>
        {/* {isAdmin && <Divider />} */}
        {isAdmin && (
          <SidebarButtonGroup title="Internal">
            <SidebarButton
              activeMenu={activeMenu}
              setActiveMenu={onChangeActiveMenu}
              menuTitle="internal__admin"
            >
              <Coffee size={16} />
              Admin
            </SidebarButton>
            <SidebarButton
              activeMenu={activeMenu}
              setActiveMenu={onChangeActiveMenu}
              menuTitle="internal__pageTemplate"
            >
              <LayoutTemplate size={16} />
              Page template
            </SidebarButton>
          </SidebarButtonGroup>
        )}
      </div>}
      <div className={classNames("settings-drawer__menu", {
        "no-padding": activeMenu === "account__plan"
      })}>
        <SettingsMenu
          currentMenuTitle={activeMenu}
          setActiveMenu={
            onChangeActiveMenu as React.Dispatch<
              React.SetStateAction<ActiveMenu>
            >
          }
          {...props}
        />
      </div>
      {/* {activeMenu === "colorsAndFonts" && <SaveChangesButtons />}
      <Modal
        title="You have unsaved changes"
        visible={isUnsavedChangesModalVisible}
        onCancel={() => setIsUnsavedChangesModalVisible(false)}
        centered
        width={300}
        footer={null}
      >
        <UnsavedChangesModal
          onDiscard={() => {
            setIsUnsavedChangesModalVisible(false);
            setActiveMenu(nextActiveMenu.current || "colorsAndFonts");
            nextActiveMenu.current = null;
          }}
        />
      </Modal> */}
    </div>
  );
};

const mapStateToProps = (state: Props) => ({
  websites: state.websites,
  auth: state.auth,
  user: state.user,
  plans: state.plans,
});
const mapActionsToProps = {
  getCurrentStoreData,
  saveWebsiteBackup,
  setUserStateData,
  getPageLoadStatus,
  getSingleBlogLoadStatus,
  getSinglePostLoadStatus,
  getSingleWebsiteLoadStatus,
};
export default connect(
  mapStateToProps,
  mapActionsToProps
)(SettingsDrawerContent);
